import React from 'react';
import classnames from 'classnames';
import { AvatarProps } from '../../types.d';

import styles from '../../Avatar.module.scss';

function CompanyAdminHappy({
  size,
  className,
}: Pick<AvatarProps, 'size' | 'className'>): JSX.Element {
  return (
    <svg
      className={classnames(className, {
        [styles[size]]: size,
      })}
      x="0px"
      y="0px"
      viewBox="0 0 144 144"
      enableBackground="new 0 0 144 143.9955139"
      xmlSpace="preserve"
    >
      <g id="athena">
        <g id="happy_4_">
          <ellipse
            fill="#A6E3F9"
            cx="72.0000153"
            cy="71.9955292"
            rx="72"
            ry="71.9977722"
          />
          <g>
            <defs>
              <ellipse
                id="SVGID_1_"
                cx="72.0000153"
                cy="71.997757"
                rx="71.9999847"
                ry="71.997757"
              />
            </defs>
            <clipPath id="SVGID_2_">
              <use
                xlinkHref="#SVGID_1_"
                overflow="visible"
              />
            </clipPath>
            <g clipPath="url(#SVGID_2_)">
              <rect
                x="6.4836159"
                y="99.6202011"
                transform="matrix(0.8329307 0.5533772 -0.5533772 0.8329307 59.1564026 12.5937443)"
                fill="#00AFEC"
                width="4.4753804"
                height="9.2949095"
              />
              <rect
                x="75.2757111"
                y="-4.6429939"
                transform="matrix(0.8660321 -0.4999884 0.4999884 0.8660321 10.382082 38.7563972)"
                fill="#00AFEC"
                width="4.4753881"
                height="9.2948933"
              />
              <rect
                x="117.2760315"
                y="120.2451477"
                transform="matrix(0.8124409 -0.5830436 0.5830436 0.8124409 -50.401947 93.1064606)"
                fill="#FFE502"
                width="4.4753757"
                height="9.294919"
              />
              <rect
                x="127.7464676"
                y="54.6935158"
                transform="matrix(0.8124409 -0.5830436 0.5830436 0.8124409 -10.2186584 86.9163742)"
                fill="#FFE502"
                width="4.4753757"
                height="9.294919"
              />
              <rect
                x="11.8136864"
                y="62.3988342"
                transform="matrix(0.8896644 0.456615 -0.456615 0.8896644 32.1647034 0.9815183)"
                fill="#FFE502"
                width="4.4753938"
                height="9.2948818"
              />
              <rect
                x="121.9772034"
                y="73.2447052"
                transform="matrix(-0.7661791 0.6426271 -0.6426271 -0.7661791 269.4413452 57.7476845)"
                fill="#00AFEC"
                width="4.4753656"
                height="9.29494"
              />
              <rect
                x="19.4291363"
                y="15.5122843"
                transform="matrix(0.8329307 0.5533772 -0.5533772 0.8329307 14.7757998 -8.6218557)"
                fill="#FFE502"
                width="4.4753804"
                height="9.2949095"
              />
              <rect
                x="95.2508621"
                y="15.5122843"
                transform="matrix(0.8329307 0.5533772 -0.5533772 0.8329307 27.4432774 -50.5798683)"
                fill="#FFE502"
                width="4.4753804"
                height="9.2949095"
              />
              <rect
                x="4.5821967"
                y="40.4008522"
                transform="matrix(-0.7661791 0.6426271 -0.6426271 -0.7661791 40.9944 75.1807632)"
                fill="#00AFEC"
                width="4.4753656"
                height="9.29494"
              />
            </g>
          </g>
          <g>
            <defs>
              <ellipse
                id="SVGID_3_"
                cx="72.0000153"
                cy="71.9999847"
                rx="72"
                ry="71.9977722"
              />
            </defs>
            <clipPath id="SVGID_4_">
              <use
                xlinkHref="#SVGID_3_"
                overflow="visible"
              />
            </clipPath>
            <g
              id="profil_6_"
              clipPath="url(#SVGID_4_)"
            >
              <g>
                <g>
                  <g>
                    <path
                      fill="#E2AE44"
                      d="M105.0084763,50.8342209C103.4059906,30.07267,85.2849197,14.5486317,64.5234833,16.151001 c-20.7611008,1.6024818-36.2855911,19.7233276-34.6832199,40.4849892 c1.6024818,20.761097,19.7238941,36.2855873,40.484993,34.6832237l17.6813812-20.637886 c10.1758728-0.7854538,17.7883148-9.6715775,17.0028534-19.8472214L105.0084763,50.8342209z"
                    />
                    <path
                      fill="#E2AE44"
                      d="M32.3218842,58.5269203l-7.7651863,4.4986725 C16.9711857,67.4202805,12.5760431,75.773941,13.250618,84.5145569l1.5353861,19.8920288l0,0 c12.5582647-0.9693222,21.9529762-11.9355087,20.9837723-24.4938889l-1.6613197-21.5235863L32.3218842,58.5269203z"
                    />
                    <path
                      fill="#00AFEC"
                      d="M84.3432617,111.1669235c-6.3853683,4.1944656-8.1615448,12.7711105-3.9672089,19.1569901 c0.3359299,0.5113831,0.709343,0.9819641,1.0978394,1.4335022l-0.0113068,0.0083771l36.0920334,42.3852386 l18.0093002-10.2062225l-32.0634308-48.8111725C99.3060226,108.7482758,90.7288589,106.971962,84.3432617,111.1669235z"
                    />
                    <path
                      fill="#00AFEC"
                      d="M84.3432617,111.1669235c-6.3853683,4.1944656-8.1615448,12.7711105-3.9672089,19.1569901 c0.3359299,0.5113831,0.709343,0.9819641,1.0978394,1.4335022l-0.0113068,0.0083771l25.4502563,29.8879089 l17.3280945-14.946228l-20.740448-31.5738373C99.3060226,108.7482758,90.7288589,106.971962,84.3432617,111.1669235z"
                    />
                    <circle
                      fill="#00AFEC"
                      cx="91.5514374"
                      cy="122.8853073"
                      r="14.2310143"
                    />
                    <path
                      fill="#00AFEC"
                      d="M105.7051239,123.5432739l-3.6839752,79.6075287H51.115715l-21.0365028-83.6018524 c-1.3915749-5.5304947,2.7898254-10.8946075,8.4928513-10.8946075h52.917263 C99.607132,108.6543427,106.0803833,115.4341125,105.7051239,123.5432739z"
                    />
                    <path
                      fill="#FDC9A3"
                      d="M48.6074905,112.3219528c-5.8337326-5.266571-14.8323326-4.8069077-20.0994492,1.026825 c-0.4217854,0.4672089-0.7932148,0.9611359-1.1417656,1.4651337l-0.0112743-0.0090866l-34.1684494,49.4098663 l16.1894207,12.8011322l40.2588806-44.5943146C54.9014282,126.5877762,54.4417686,117.5886307,48.6074905,112.3219528z"
                    />
                    <path
                      fill="#00AFEC"
                      d="M48.6074905,112.3219528c-5.8337326-5.266571-14.8323326-4.8069077-20.0994492,1.026825 c-0.4217854,0.4672089-0.7932148,0.9611359-1.1417656,1.4651337l-0.0112743-0.0090866L5.293335,146.7074738 l17.9512691,14.946228l26.3902531-29.232193C54.9014282,126.5877762,54.4417686,117.5886307,48.6074905,112.3219528z"
                    />
                    <path
                      fill="#283042"
                      d="M108.0382233,58.5809479c-0.0118179,0.0094719-0.0118179,0.0094719-0.0118179,0.0094719"
                    />
                    <path
                      fill="#FDC9A3"
                      d="M60.3528938,110.5686874c1.0720329,6.5634537,7.2617607,11.0150299,13.8252144,9.9429932 c6.563446-1.0720291,11.0150223-7.2618637,9.9429855-13.8253174 c-1.0720291-6.5634537-7.2618637-11.0150299-13.8252106-9.9429932 C63.7324295,97.8153992,59.2807503,104.0052338,60.3528938,110.5686874z"
                    />
                    <polygon
                      fill="#FDC9A3"
                      points="84.1210938,106.6863632 60.3528938,110.5686874 55.5723648,81.3014069 56.2696838,81.1875076 79.3406754,77.4191818"
                    />
                    <path
                      fill="#FDC9A3"
                      d="M70.6965332,28.1754951L68.8478165,28.47752 c-11.7986107,1.9270992-19.8009262,13.0540009-17.8737183,24.8524971l6.5731964,40.2429047l22.3778305-3.6551819 c11.2382355-1.8356934,18.8604736-12.4340744,17.0247803-23.6722031l-3.5513992-21.7430191 C91.6381302,33.7249336,81.4740067,26.4151173,70.6965332,28.1754951z"
                    />
                    <path
                      fill="#FFFFFF"
                      d="M75.638092,74.7013931c0.371788,3.3044662,3.3519897,5.6818695,6.656456,5.3100815 c3.3044662-0.3717957,5.6818771-3.3519897,5.3100815-6.6564636L75.638092,74.7013931z"
                    />
                    <path
                      fill="#FDC9A3"
                      d="M51.6520157,69.517189l4.9126091-0.7988205l-0.7960587-4.9025154 c-0.4396324-2.7075272-2.9955482-4.5447655-5.7086525-4.1036072l0,0 c-2.7131882,0.4411736-4.556179,2.9938049-4.1164589,5.701313l0,0 C46.3831062,68.1211777,48.9389343,69.9584351,51.6520157,69.517189z"
                    />
                    <path
                      fill="#E2AE44"
                      d="M49.3236427,60.3538742l-2.6704369,0.272583l-1.4715576-30.5739079l45.5499954-4.6537323 l2.7279282,15.4226818l-2.1721497,0.2626114c-8.8146896,0.9005394-17.0901566,4.700573-23.5703583,10.823513 l-0.0001144,0.0000038C62.660099,56.685585,56.202301,59.651062,49.3236427,60.3538742L49.3236427,60.3538742z"
                    />
                    <path
                      fill="#0E0E11"
                      d="M89.7448654,55.5417404c-0.0165482,0-0.0339203-0.0008278-0.0504608-0.0028954l-5.7135086-0.6778755 c-0.2324448-0.02771-0.3987198-0.2382278-0.3705902-0.470665c0.027298-0.2328491,0.2522964-0.3962173,0.4698486-0.370575 l5.7135162,0.6778755c0.2324448,0.02771,0.3987122,0.2382278,0.3705826,0.470665 C90.1394424,55.3833351,89.9558029,55.5417404,89.7448654,55.5417404z"
                    />
                    <path
                      fill="#0E0E11"
                      d="M69.1317215,57.028183c-0.1919098,0-0.3647919-0.1302795-0.4119492-0.3246689 c-0.0545959-0.2270584,0.0852051-0.4557762,0.3126907-0.5107841l6.0650711-1.4587326 c0.2340927-0.0562477,0.4557877,0.0856133,0.5112076,0.3130913c0.0545959,0.2270584-0.0851974,0.4557762-0.3126831,0.5107803 l-6.0650711,1.4587326C69.1978989,57.0244598,69.1639862,57.028183,69.1317215,57.028183z"
                    />
                    <ellipse
                      transform="matrix(0.9984511 -0.0556374 0.0556374 0.9984511 -3.2855706 4.1304173)"
                      fill="#0E0E11"
                      cx="72.5378113"
                      cy="61.0727081"
                      rx="1.6214505"
                      ry="2.0923121"
                    />
                    <ellipse
                      transform="matrix(0.9984511 -0.0556374 0.0556374 0.9984511 -3.2206168 4.9065857)"
                      fill="#0E0E11"
                      cx="86.5099487"
                      cy="60.2942467"
                      rx="1.6214505"
                      ry="2.0923121"
                    />
                  </g>
                </g>
              </g>
              <path
                fill="#00AFEC"
                d="M68.6255112,143.8528442l21.0233765-15.9402695l16.8584671,22.2262344l-0.0120697,0.0089264 c0.9376678,1.2358246,1.6827011,2.6490936,2.1483383,4.2252655c2.0631332,6.9854431-1.9269867,14.3204651-8.912323,16.383606 c-5.4091568,1.5979919-11.0171509-0.4447479-14.2353516-4.6869659l-0.0120697,0.0094452L68.6255112,143.8528442z"
              />
              <g>
                <polygon
                  fill="#FDC9A3"
                  points="133.4762268,173.5867767 164.1596832,127.7610703 153.4922028,119.8281784 116.8368912,160.8442841"
                />
              </g>
            </g>
          </g>
          <path
            fill="#FFE500"
            d="M48.7334671,39.9528122c-0.267662-1.0706139-1.1812439-32.1366425-1.1812439-32.1366425 l19.4012299,26.2482738L48.7334671,39.9528122z"
          />
        </g>
      </g>
    </svg>
  );
}

export default CompanyAdminHappy;
